import { supabase } from '../../lib/supabase';
import { IFunnelRepository } from '../../domain/repositories/IFunnelRepository';
import { Funnel } from '../../types';
import { InfrastructureError } from '../../core/errors/DomainErrors';

export class SupabaseFunnelRepository implements IFunnelRepository {
    async findAll(organizationId?: string): Promise<Funnel[]> {
        let query = supabase
            .from('funnels')
            .select('id, name, created_at, organization_id')
            .order('created_at', { ascending: true });

        if (organizationId) {
            query = query.eq('organization_id', organizationId);
        }

        const { data, error } = await query;

        if (error) {
            throw new InfrastructureError(`Erro ao buscar funis: ${error.message}`, error);
        }

        return data || [];
    }

    async findById(id: string): Promise<Funnel | null> {
        const { data, error } = await supabase
            .from('funnels')
            .select('id, name, created_at, organization_id')
            .eq('id', id)
            .single();

        if (error) {
            if (error.code === 'PGRST116') return null;
            throw new InfrastructureError(`Erro ao buscar funil: ${error.message}`, error);
        }

        return data;
    }

    async save(funnel: Funnel, organizationId?: string): Promise<Funnel> {
        const isNew = !funnel.id || funnel.id.startsWith('temp_');

        if (isNew) {
            const { id, ...dataWithoutId } = funnel;

            const funnelToInsert = {
                name: funnel.name,
                ...(organizationId ? { organization_id: organizationId } : {})
            };

            const { data, error } = await supabase
                .from('funnels')
                .insert([funnelToInsert])
                .select()
                .single();

            if (error) {
                throw new InfrastructureError(`Erro ao criar funil: ${error.message}`, error);
            }
            return data;
        } else {
            const { error } = await supabase
                .from('funnels')
                .update({ name: funnel.name })
                .eq('id', funnel.id);

            if (error) {
                throw new InfrastructureError(`Erro ao atualizar funil: ${error.message}`, error);
            }
            return funnel;
        }
    }

    async delete(id: string): Promise<void> {
        const { error } = await supabase
            .from('funnels')
            .delete()
            .eq('id', id);

        if (error) {
            throw new InfrastructureError(`Erro ao deletar funil: ${error.message}`, error);
        }
    }
}
